import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InfoWindow } from 'react-google-maps';
import { Container, Header, Icon, Table } from 'semantic-ui-react';
import i18next from 'i18next';

import './BranchInfoBox.scss';

class BranchInfoBox extends Component {

    render() {
        const { restaurant, turnOffDescription } = this.props;

        return (
            <InfoWindow onCloseClick={turnOffDescription} options={{ maxWidth: 800 }}>
                <Container fluid className='pi-branch-info-window'>
                    <Header className='pi-branch-info-window-header'>
                        <Icon color='grey' name='marker' />
                        <Header.Content>
                            {restaurant.name}
                        </Header.Content>
                    </Header>
                    <Table collapsing basic='very' className='pi-branch-info-window-table'>
                        <Table.Body>
                            {restaurant.branch && <Table.Row>
                                <Table.Cell>{i18next.t('branch')}</Table.Cell>
                                <Table.Cell>{restaurant.branch}</Table.Cell>
                            </Table.Row>}
                            <Table.Row>
                                <Table.Cell>{i18next.t('address')}</Table.Cell>
                                <Table.Cell>{restaurant.address}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Container>
            </InfoWindow>
        );
    }
}

BranchInfoBox.propTypes = {
    restaurant: PropTypes.object,
    
    turnOffDescription: PropTypes.func
};

export default BranchInfoBox;
